/**
 * What texting does during a LimePhone trial, in one place for the server's
 * refusal and every screen that explains it (owner, 2026-10-25).
 *
 * Matches what the server actually does:
 *   - OUTBOUND: every outbound SMS send path refuses while
 *     organizations.lifecycle = 'trialing' (server/routes.ts
 *     trialOutboundSmsBlocked + /api/sms/send). That is true for every trial
 *     number; the 10DLC sentence is the reason US carriers give, and after the
 *     trial US texting still needs a 10DLC registration ($25 one-time).
 *   - INBOUND CODES: enhancedSmsService drops inbound verification-code texts
 *     (utils/verificationCodeSms) unless staff set organizations.trusted_inbound.
 *     Owner decision 2026-10-25: the block is for TRIAL numbers; paying
 *     accounts are being unblocked in a separate server change. All copy here
 *     is therefore scoped to the trial — never say it applies to every account.
 * If either rule changes, change this file, not the screens.
 */
export const TRIAL_SMS_OUTBOUND_NOTE =
  "Outbound SMS isn't available during the trial: US carriers require 10DLC registration for business texting.";

export const TRIAL_SMS_INBOUND_CODES_NOTE =
  'Inbound texts from verification services (e.g. one-time codes from banks, apps, Google) are blocked on trial numbers to prevent abuse.';

export const TRIAL_SMS_UNLOCK_NOTE =
  'Texting starts when your trial ends and your 10DLC registration ($25 one-time) is approved.';

/** The body every outbound send path returns when a trial tries to text. */
export const TRIAL_SMS_REFUSAL = {
  message: `${TRIAL_SMS_OUTBOUND_NOTE} ${TRIAL_SMS_UNLOCK_NOTE}`,
  reason: 'trial_restriction',
  code: 'TRIAL_SMS_OUTBOUND',
  upgradeUrl: '/settings/billing',
} as const;

/** +1 numbers: the US and Canada (NANP), the countries the notes are about. */
export function isUsCaNumber(e164: unknown): boolean {
  return typeof e164 === 'string' && /^\+1\d{10}$/.test(e164.replace(/[^\d+]/g, ''));
}

/** Is this API error the trial SMS refusal? */
export function isTrialSmsRefusal(err: any): boolean {
  const d = err?.data ?? err;
  return d?.reason === 'trial_restriction' || d?.code === 'TRIAL_SMS_OUTBOUND';
}
